import { logException } from "@wss/error-tracking";
import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";

const sendInterestFormEmail = async (
  zipcode: string,
  email: string,
  itemNumber: string,
): Promise<Throwable<boolean>> => {
  const getEmailEndpoint = `/services/installation/sendinterestformemail/?zipcode=${zipcode}&email=${email}&itemNumber=${itemNumber.toUpperCase()}`;

  try {
    const response = await fetch(getEmailEndpoint);
    return { isError: false, value: response.ok };
  } catch (e) {
    const error = new Error("Error in sendInterestFormEmail", {
      cause: toError(e),
    });

    await logException(error);

    return { error, isError: true };
  }
};

export default sendInterestFormEmail;
